import styled from '@emotion/styled';
import { StyledDiv } from 'theme/commonStyled';

export const StyledRealTimeText = styled(StyledDiv)`
  padding: ${({ theme }): string => `${theme.sizes[3]}px 0`};
  transition: all 0.15s ease-in-out;
`;
